
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.746 6.998a3.184 3.184 0 100-6.368 3.184 3.184 0 000 6.368zM12.803 13.365a6.358 6.358 0 00-12.108 0h12.108z","stroke":"#fff","stroke-width":".98","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    